import { APP_LOAD, LOAD_PROJECT, LOGOUT, UPDATE_PROJECT, CREATE_DOMAIN, UPDATE_DOMAIN, DESTROY_DOMAIN, DESTROY_PROJECT, CREATE_LINK } from '../actions/actionTypes.js';
import findIndex from 'lodash/findIndex';
import filter from 'lodash/filter';
import omit from 'lodash/omit';

const initialState = {}

export const currentProject = (state = initialState, rawAction) => {
  let didx = null
  const action = {...rawAction, payload: omit(rawAction.payload, 'success_msg')}
  
  switch (action.type) {
    case APP_LOAD.SUCCESS:
      return action.payload[1]
    case LOAD_PROJECT.SUCCESS:
      return action.payload
    case UPDATE_PROJECT.SUCCESS:
      if (state.id === action.payload.id){
        return {...state, ...action.payload}
      }
      else
        return state;
    // DOMAINS
    case CREATE_DOMAIN.SUCCESS:
      if (state.id !== action.payload.project_id)
        return state;
      return {
        ...state,
        domains: [
          ...filter(state.domains, ({id}) => (id !== action.payload.id)),
          action.payload
        ]
      };
    case UPDATE_DOMAIN.SUCCESS:
      if (state.id !== action.payload.project_id)
        return state;
      didx = findIndex(state.domains, {id: action.payload.id})
      return {
        ...state,
        domains: [
          ...state.domains.slice(0, didx),
          action.payload,
          ...state.domains.slice(didx + 1)
        ]
      };
    case DESTROY_DOMAIN.SUCCESS:
      if (state.id !== action.payload.project_id)
        return state;
      didx = findIndex(state.domains, {id: action.payload.id})
      return {
        ...state,
        domains: [
          ...state.domains.slice(0, didx),
          ...state.domains.slice(didx + 1)
        ]
      };
    
    case CREATE_LINK.SUCCESS:
      return {...state, usage: {...(state.usage || {}), links: ((state.usage || {links:0}).links || 0) + 1 } };
    case DESTROY_PROJECT.SUCCESS:
      if (parseInt(state.id, 10) === parseInt(action.payload.id, 10)) {
        localStorage.removeItem('projectId')
        return initialState
      }
      else
        return state  
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/currentProject.js